import type { JSX } from 'react'
import type { INotificationToast } from './NotificationToast.h'

import { NotificationToast } from './NotificationToast'
import { NotificationToastContainerSC } from './NotificationToast.styled'

export interface INotificationToastsContainerProps {
  toasts: INotificationToast[]
  onClose: (id: string) => void
}

export const NotificationToastsContainer = ({
  toasts,
  onClose,
}: INotificationToastsContainerProps): JSX.Element | null => {
  if (toasts.length === 0) {
    return null
  }

  return (
    <NotificationToastContainerSC>
      {toasts.map((toast) => (
        <NotificationToast
          key={toast.id}
          {...toast}
          onClose={() => onClose(toast.id)}
        />
      ))}
    </NotificationToastContainerSC>
  )
}
